import { speciaBehiver, specialCheckCurrent } from '@/define/limit'

export interface ReadSettingsRefreshPolicy {
  mode: 'immediate' | 'deferred'
  delayMs?: number
}

const immediatePolicy: ReadSettingsRefreshPolicy = { mode: 'immediate' }

const deferredPolicy = (delayMs: number): ReadSettingsRefreshPolicy => ({ mode: 'deferred', delayMs })

/**
 * @param isSaveOp 是否为写入操作（改键/宏/磁轴），写入后设备需要处理延迟
 * @param isLightOp 是否为灯效写入操作，键盘处理灯效需要缓冲时间
 */
export const resolveReadSettingsRefreshPolicy = (isSaveOp: boolean, isLightOp: boolean = false): ReadSettingsRefreshPolicy => {
  if (specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen) && isSaveOp) {
    return deferredPolicy(1500)
  }

  if (specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V1) && isSaveOp) {
    return deferredPolicy(200)
  }

  // 灯效写入后键盘需要缓冲时间，立即读回容易拿到旧数据
  if (isLightOp) {
    return deferredPolicy(500)
  }

  return immediatePolicy
}
